import React from 'react';

import {AccordionGroupItem as CoreAccordionGroupItem} from 'brandComponents/core/AccordionGroup';

import {IAccordionProps} from './IAccordion';

const Accordion = (props: IAccordionProps) => {
	return <CoreAccordionGroupItem {...props} />;
};

export default Accordion;
